var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { INotificationConfig } from "./config";
import Humane from "humane-js";
import extend from "extend";
import { DI, IPlatform } from "@aurelia/kernel";
import { I18N } from '@aurelia/i18n';
export const INotification = DI.createInterface('INotification', x => x.singleton(Notification));
let Notification = class Notification {
    constructor(config, platform, i18n) {
        this.config = config;
        this.platform = platform;
        this.i18n = i18n;
        this.humane = Humane;
        this.setBaseCls();
        for (let key in config.notifications) {
            if (config.notifications.hasOwnProperty(key)) {
                this[key] = this.spawn(config.notifications[key]);
            }
        }
    }
    setBaseCls(baseCls = this.config.defaults.baseCls) {
        this.humane.baseCls = baseCls ? baseCls : this.humane.baseCls;
        this.notify = this.humane.create();
    }
    spawn(addnDefaults) {
        addnDefaults =
            typeof addnDefaults === "string"
                ? { addnCls: addnDefaults }
                : addnDefaults;
        let defaults = extend({}, this.config.defaults, addnDefaults);
        return (message, options) => {
            return this.log(message, options, defaults);
        };
    }
    translate(options = {}, defaults = {}) {
        let joined = extend({}, this.config, defaults, options);
        return joined.translate;
    }
    log(message, options = {}, defaults = this.config.defaults) {
        if (this.translate(options, defaults)) {
            if (message instanceof Array) {
                message = message.map(item => this.i18n.tr(item));
            }
            else {
                message = this.i18n.tr(message);
            }
        }
        return new Promise(resolve => {
            return this.notify.log(message, options, resolve, defaults);
        });
    }
    remove() {
        return new Promise(resolve => {
            return this.notify.remove(resolve);
        });
    }
    /**
     * Notify 'note' (translated if applicable) using humane.log.
     *
     * @param {string|string[]}  message|multi-line message.
     * @param {{}}               [options] for this particular notification.
     * @param {{}}               [defaults] for this type of notification.
     *
     */
    note(message, options = {}, defaults = this.config.defaults) { } // eslint-disable-line  no-empty-function
    /**
     * Notify 'success' (translated if applicable) using humane.log.
     *
     * @param {string|string[]}  message|multi-line message.
     * @param {{}}               [options] for this particular notification.
     * @param {{}}               [defaults] for this type of notification.
     *
     */
    success(message, options = {}, defaults = this.config.defaults) { } // eslint-disable-line  no-empty-function
    /**
     * Notify 'error' (translated if applicable) using humane.log.
     *
     * @param {string|string[]}  message|multi-line message.
     * @param {{}}               [options] for this particular notification.
     * @param {{}}               [defaults] for this type of notification.
     *
     */
    error(message, options = {}, defaults = this.config.defaults) { } // eslint-disable-line  no-empty-function
    /**
     * Notify 'info' (translated if applicable) using humane.log.
     *
     * @param {string|string[]}  message|multi-line message.
     * @param {{}}               [options] for this particular notification.
     * @param {{}}               [defaults] for this type of notification.
     *
     */
    info(message, options = {}, defaults = this.config.defaults) { } // eslint-disable-line  no-empty-function
};
Notification = __decorate([
    __param(0, INotificationConfig),
    __param(1, IPlatform),
    __param(2, I18N),
    __metadata("design:paramtypes", [Object, Object, Object])
], Notification);
export { Notification };
//# sourceMappingURL=aurelia-notification.js.map